<template>
  <div id="app">
    <Mitsumori/>
  </div>
</template>

<script>
  import Mitsumori from './components/Mitsumori'

  export default {
    name : 'App',
    components : {
      Mitsumori
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue